import useConditionalEffect from 'hooks/useConditionalEffect'
import { Stream } from 'interfaces'
import { useCallback, useRef } from 'react'
import { connect } from 'react-redux'
import { Observable, animationFrameScheduler, from } from 'rxjs'
import { observeOn } from 'rxjs/operators'
import { getStream } from 'services/content/streams/actions'
import { StoreState, StoreThunkDispatch } from 'store/state'

export interface FetchStreamOwnProps {
  id: string
  onFetched(folder: Stream): void
  children?: React.ReactNode
  onFailed?(err: any): void
}

interface ConnectedFetchStreamProps extends Omit<FetchStreamOwnProps, 'children'> {
  getStream(): Observable<Stream>
  children?: React.ReactNode
}

export type FetchStreamProps = FetchStreamOwnProps & ConnectedFetchStreamProps

const FetchStream = ({
  id,
  children,
  onFetched,
  onFailed,
  getStream: getStreamAction
}: FetchStreamProps) => {
  const subscriptionRef = useRef<any>(null)

  const handleFailed = useCallback((err: any) => {
    console.log(err)
    if (onFailed) {
      onFailed(err)
    }
  }, [onFailed])

  const fetch = useCallback(() => {
    return getStreamAction().pipe(
      observeOn(animationFrameScheduler)
    )
      .subscribe({ next: onFetched, error: handleFailed })
  }, [getStreamAction, onFetched, handleFailed])

  useConditionalEffect(([_fetch]) => {
    subscriptionRef.current = _fetch()

    return () => {
      subscriptionRef.current?.unsubscribe()
    }
  }, [id], [fetch])
  
  return children || null
}

function mapStateToProps(_state: StoreState, ownProps: FetchStreamOwnProps) {
  return ownProps
}

function mapDispatchToProps(dispatch: StoreThunkDispatch, ownProps: FetchStreamOwnProps) {
  const { id } = ownProps

  return {
    getStream: () => from(dispatch(getStream({ streamId: id, force: true, withFeeds: true })).unwrap())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FetchStream as any)
